import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.LicenseArea");
const LicenseArea = function () {
    let interaction_end = () => {
        $("#license_area").hide();
        $("body").off("click.license_area.btn", "#license_area .btn");
    };
    this.interact = async function () {
        try {
            const license = await global.server.mtac_license_retrieve();
            $("#license_area .content").html(license);
        } catch (error) {
            log.warn("no license has been specified for this organization");
            return true;
        }
        return new Promise((resolve) => {
            let handlers = {
                accept: () => {
                    interaction_end();
                    resolve(true);
                },
                decline: () => {
                    alert(global.internationalization.text("startup.Accept-license-to-go-on"));
                }
            };
            $("#license_area").css("display", null);
            $("body").on("click.license_area.btn", "#license_area .btn", (event) => {
                handlers[$(event.currentTarget).data("method")]();
            });
        });
    };
};
export default new LicenseArea();
